import React, {forwardRef, useEffect, useRef, useState} from 'react';
import UniversalKeyboard from 'components/universal/input/UniversalKeyboard';

const keyboardWidth = 670;
const keyboardHeight = 285;

const UniversalKeyboardSizeWrapper = forwardRef(({onKeyPress, isPictureComment, highlightedKey}, ref) => {
    const parentRef = useRef(null);
    const [scale, setScale] = useState(1);
    const [scaledHeight, setScaledHeight] = useState(0);

    useEffect(() => {
        function handleResize() {
            if (parentRef.current) {
                const parentWidth = parentRef.current.offsetWidth;
                console.log('parent width: ' + parentWidth);
                const newScale = parentWidth / keyboardWidth * 0.95;
                setScale(newScale);
                console.log('new scale: ' + newScale);
                setScaledHeight(keyboardHeight * newScale);
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    return (
        <div className={`keyboard-wrapper-parent ${isPictureComment ? 'comment' : 'chat'}`} ref={parentRef}>
            <div className="keyboard-wrapper-scaling-wrapper" style={{height: scaledHeight}}>
                <div
                    className="keyboard-wrapper-content"
                    style={{transform: `translateX(-50%) scale(${scale})`}}
                >
                    <UniversalKeyboard
                        ref={ref}
                        onKeyPress={onKeyPress}
                        isPictureComment={isPictureComment}
                        highlightedKey={highlightedKey}
                    />
                </div>
            </div>
        </div>
    );
});

export default UniversalKeyboardSizeWrapper;
